var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvestments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.15289 0.367188H18.8471C19.76 0.367188 20.5 1.22201 20.5 2.27648V8.95918H18.682V7.04987H2.31836V13.7325H10.5V15.6415H2.15289C1.24003 15.6415 0.5 14.7867 0.5 13.7322V2.27648C0.5 1.22201 1.24003 0.367188 2.15289 0.367188ZM18.682 2.27675V5.14058H2.31836V2.27675H18.682ZM12.3184 13.7322H16.4873L15.3119 14.9665L16.5975 16.3165L19.9676 12.7776L16.5975 9.2386L15.3119 10.5887L16.4873 11.8229H12.3184V13.7322Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestments);
export default __webpack_public_path__ + "static/media/investments.48d1232506035f026a5f58c624edb8b0.svg";
export { ForwardRef as ReactComponent };